import React, { useState, useEffect } from 'react';

const DarkModeSwitch = () => {
  const [enabled, setEnabled] = useState(
    localStorage.getItem('theme') === 'dark'
  );

  useEffect(() => {
    const root = window.document.documentElement;
    if (enabled) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [enabled]);

  return (
    <button 
      onClick={() => setEnabled(!enabled)}
      className={`w-12 h-7 flex items-center rounded-full p-1 transition-colors duration-300
        ${enabled ? 'bg-[#2D2D2D]' : 'bg-gray-300'}`}
    >
      <div
        className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-300
          ${enabled ? 'translate-x-5' : 'translate-x-0'}`}
      />
    </button>
  );
};

export default DarkModeSwitch;
